import styled from 'styled-components';
import { media } from '@/Shared/theme';

const StyledIcon = styled.div`
	align-items: center;
	color: var(--label-text);
	cursor: pointer;
	display: flex;

	svg {
		transition: color 0.15s ease-in;
	}

	span {
		display: none;
		margin-left: var(--spacing-2);
		${media.condensed} {
			display: inline;
		}
	}
`;

const SiteSettingIcon = () => (
	<StyledIcon>
		<svg
			width="34"
			viewBox="0 0 512 512"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor">
			<path d="m504.426 211.619-61.969-15.497a195.792 195.792 0 0 0-12.251-29.659l32.839-54.738a10 10 0 0 0-1.504-12.215l-49.05-49.051a10.001 10.001 0 0 0-12.216-1.504l-54.739 32.84a195.484 195.484 0 0 0-29.659-12.254L300.381 7.574A10 10 0 0 0 290.68 0h-69.36a10 10 0 0 0-9.701 7.574L196.123 69.54a195.442 195.442 0 0 0-29.659 12.254l-54.739-32.84a10 10 0 0 0-12.216 1.504l-49.05 49.051a10 10 0 0 0-1.504 12.215l32.839 54.738a195.792 195.792 0 0 0-12.251 29.659L7.574 211.619A10 10 0 0 0 0 221.32v69.36a10 10 0 0 0 7.574 9.701l61.969 15.497a195.792 195.792 0 0 0 12.251 29.659l-32.839 54.738a10 10 0 0 0 1.504 12.215l49.05 49.051a10 10 0 0 0 12.216 1.504l54.74-32.841a196.18 196.18 0 0 0 29.657 12.252l15.497 61.969a10 10 0 0 0 9.701 7.574h69.359a10 10 0 0 0 9.701-7.574l15.497-61.969a196.18 196.18 0 0 0 29.657-12.252l54.74 32.841a10.002 10.002 0 0 0 12.216-1.504l49.05-49.051a10 10 0 0 0 1.504-12.215l-32.839-54.738a195.792 195.792 0 0 0 12.251-29.659l61.969-15.497a10 10 0 0 0 7.574-9.701v-69.36a9.997 9.997 0 0 0-7.573-9.701zM492 282.873l-59.886 14.976a10.002 10.002 0 0 0-7.183 6.929c-3.66 12.688-8.695 24.872-14.964 36.215a9.999 9.999 0 0 0 .177 9.982l31.733 52.895-38.009 38.009-52.895-31.733a10.004 10.004 0 0 0-9.977-.18c-11.382 6.282-23.568 11.317-36.22 14.967a10.002 10.002 0 0 0-6.93 7.182L282.872 492h-53.744l-14.977-59.886a9.999 9.999 0 0 0-6.93-7.182c-12.651-3.649-24.838-8.685-36.22-14.967a10.004 10.004 0 0 0-9.977.18l-52.895 31.733-38.007-38.008 31.733-52.895a10.001 10.001 0 0 0 .177-9.982c-6.269-11.343-11.304-23.527-14.964-36.215a10 10 0 0 0-7.183-6.929L20 282.873v-53.746l59.886-14.976a10.002 10.002 0 0 0 7.183-6.929c3.66-12.688 8.695-24.872 14.964-36.215a9.999 9.999 0 0 0-.177-9.982L70.122 108.13l38.009-38.009 52.895 31.733a10 10 0 0 0 9.979.179 175.243 175.243 0 0 1 36.212-14.964 10 10 0 0 0 6.936-7.184L229.128 20h53.744l14.977 59.886a10 10 0 0 0 6.936 7.184 175.243 175.243 0 0 1 36.212 14.964 9.998 9.998 0 0 0 9.979-.179l52.895-31.733 38.009 38.009-31.733 52.895a10.001 10.001 0 0 0-.177 9.982c6.269 11.343 11.304 23.527 14.964 36.215a10 10 0 0 0 7.183 6.929L492 229.127z" />
			<circle cx="350" cy="340" r="10" />
			<path d="M256 120c-74.99 0-136 61.009-136 136s61.01 136 136 136c21.955 0 43.785-5.379 63.131-15.557 4.888-2.572 6.766-8.619 4.193-13.506s-8.62-6.765-13.506-4.194C293.334 367.416 274.724 372 256 372c-63.963 0-116-52.038-116-116s52.037-116 116-116 116 52.038 116 116c0 14.476-2.644 28.601-7.857 41.981-2.006 5.146.541 10.943 5.687 12.949 5.151 2.004 10.944-.542 12.948-5.687C388.897 289.538 392 272.97 392 256c0-74.991-61.01-136-136-136z" />
		</svg>
		<span>Settings</span>
	</StyledIcon>
);

export default SiteSettingIcon;
